module.exports = __webpack_public_path__ + "static/media/history_28.9425fd37.jpg";